import script from "./DropdownMultiple.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20string"
export * from "./DropdownMultiple.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20string"

const __exports__ = script;

export default __exports__